<template>
  <v-snackbar
    v-model="isShow"
    :color="color"
    :timeout="notificationTimeout"
    top
    style="z-index: 100"
  >
    <p class="notification-text">
      {{ message }}
    </p>
    <template #action="{ attrs }">
      <v-btn
        v-bind="attrs"
        min-width="100"
        text
        @click="resetAlert"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'NotificationBar',

  data () {
    return {
      appColor: this.$appConfig.color
    }
  },

  computed: {
    ...mapGetters('notification', ['show', 'message', 'isError', 'notificationTimeout']),

    isShow: {
      get () {
        return this.show
      },
      set (val) {
        return val ? this.SHOW_NOTIFICATION() : this.RESET_ALERT()
      }
    },

    color () {
      return this.isError ? this.appColor.error : this.appColor.secondary
    }
  },

  methods: {
    ...mapMutations('notification', ['SHOW_NOTIFICATION', 'RESET_ALERT']),
    ...mapActions('notification', ['resetAlert'])
  }
}
</script>

<style lang="scss" scoped>
  .notification-text {
    max-height: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    margin-bottom: 0;
  }
</style>
